
const digest = '657262dc47bff01adade7813352dc60fccbe510dd5a775f340258d8e027b257f';
const classes = {"items":"_items_f96kz_1"};
const css = `._items_f96kz_1 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  background-color: #ffffff;
  border: 1px solid #eaedf3;
  border-bottom: 0;
  padding: 0 12px;
  column-gap: 24px;
  width: 100%;
  align-items: center;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  